/**
 * Parse a `clucks/YYYY-MM.md` activity log (the coop's append-only log of
 * hatch/peck/etc. activity). The format:
 *
 *   # Clucks — 2026-08
 *
 *   ## [2026-08-30] hatch | 2026 Team Retro
 *   - team-retro
 *   - jane-doe
 *
 *   ## [2026-08-30] peck | what did we decide about timelines?
 *   - migration-plan
 *
 * Tolerant of a trailing partial `##` block (a file read mid-append on Dropbox).
 */
import type { CluckEntry } from './coop-types.js';

const HEADING_RE = /^##\s+\[(\d{4}-\d{2}-\d{2})\]\s+(\S+)\s+\|\s+(.*)$/;
const BULLET_RE = /^-\s+(.*)$/;

export function parseClucksFile(md: string): CluckEntry[] {
  const entries: CluckEntry[] = [];
  let current: CluckEntry | null = null;

  for (const rawLine of md.split('\n')) {
    const line = rawLine.replace(/\r$/, '');
    const heading = HEADING_RE.exec(line);
    if (heading) {
      if (current) entries.push(current);
      current = { date: heading[1]!, kind: heading[2]!, title: heading[3]!.trim(), slugs: [] };
      continue;
    }
    if (!current) continue;
    const bullet = BULLET_RE.exec(line.trim());
    if (bullet) {
      const slug = bullet[1]!.trim();
      if (slug) current.slugs.push(slug);
    }
  }
  if (current) entries.push(current);
  return entries;
}

/** `"clucks/2026-08.md"` -> `"2026-08"`; anything else -> `null`. */
export function monthFromCluckPath(path: string): string | null {
  const m = /clucks\/(\d{4}-\d{2})\.md$/i.exec(path);
  return m ? m[1]! : null;
}
